exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ca-error-container{text-align:center;width:100%;color:#d90000;margin-top:8px;margin-bottom:16px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/CreditAssessmentErrorMessage/CreditAssessmentErrorMessage.scss
 ** module id = 1225
 ** module chunks = 0
 **/